module.exports = __webpack_public_path__ + "img/9.956c2076.png";